import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/unmspace/cecUnmProject/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/unmspace/cecUnmProject/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/unmspace/cecUnmProject/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/unmspace/cecUnmProject/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/unmspace/cecUnmProject/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/unmspace/cecUnmProject/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/unmspace/cecUnmProject/import',
      method: 'post',
      data: data
    })
  }
}
